// src/routes/hotelMealPlansRoutes.jsx
import React from 'react';
import { Route } from 'react-router-dom';
import HotelMealPlans from '../pages/hotelMealPlans/HotelMealPlans';
import CreateHotelMealPlan from '../pages/hotelMealPlans/CreateHotelMealPlan';
import EditHotelMealPlan from '../pages/hotelMealPlans/EditHotelMealPlan';
import ProtectedRoute from '../components/global/ProtectedRoute';

const hotelMealPlansRoutes = (
    <>
        {/* Hotel Meal Plans List */}
        <Route
            path="/hotel-meal-plans"
            element={
                <ProtectedRoute requiredPermission="hotel_meal_plans_list">
                    <HotelMealPlans />
                </ProtectedRoute>
            }
        />

        {/* Hotel Meal Plans Archive */}
        <Route
            path="/hotel-meal-plans/archive"
            element={
                <ProtectedRoute requiredPermission="hotel_meal_plans_archive_list">
                    <HotelMealPlans />
                </ProtectedRoute>
            }
        />

        {/* Create Hotel Meal Plan */}
        <Route
            path="/hotel-meal-plans/create"
            element={
                <ProtectedRoute requiredPermission="hotel_meal_plans_create">
                    <CreateHotelMealPlan />
                </ProtectedRoute>
            }
        />

        {/* Edit Hotel Meal Plan */}
        <Route
            path="/hotel-meal-plans/:id/edit"
            element={
                <ProtectedRoute requiredPermission="hotel_meal_plans_edit">
                    <EditHotelMealPlan />
                </ProtectedRoute>
            }
        />
    </>
);

export default hotelMealPlansRoutes;
